import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { 
  FileText, 
  Plus,
  Edit,
  Eye,
  Building2,
  TrendingUp
} from 'lucide-react';
import { toast } from 'sonner';

const AdminCaseStudiesPage = () => {
  const [caseStudies, setCaseStudies] = useState([
    { id: '1', title: 'Augmentation de 150% du trafic', client: 'E-Shop Pro', sector: 'E-commerce', published: true },
    { id: '2', title: 'Refonte UX réussie', client: 'FinTech Solutions', sector: 'Finance', published: true },
    { id: '3', title: 'Lancement app mobile', client: 'HealthCare+', sector: 'Santé', published: false },
  ]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#1a365d]">Études de cas</h1>
          <p className="text-[#64748b]">Présentez vos succès clients détaillés</p>
        </div>
        <Button className="bg-amber-600 hover:bg-amber-700">
          <Plus className="w-4 h-4 mr-2" />
          Nouvelle étude
        </Button>
      </div>

      <div className="space-y-4">
        {caseStudies.map((study) => (
          <Card key={study.id} className="hover:shadow-md transition-shadow">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-lg bg-amber-100 flex items-center justify-center">
                    <TrendingUp className="w-6 h-6 text-amber-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#1a365d]">{study.title}</h3>
                    <div className="flex items-center gap-2 text-sm text-[#64748b]">
                      <Building2 className="w-3 h-3" />
                      <span>{study.client}</span>
                      <span>•</span>
                      <span>{study.sector}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Badge variant={study.published ? 'default' : 'secondary'}>
                    {study.published ? 'Publié' : 'Brouillon'}
                  </Badge>
                  <Button variant="ghost" size="icon"><Eye className="w-4 h-4" /></Button>
                  <Button variant="ghost" size="icon"><Edit className="w-4 h-4" /></Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminCaseStudiesPage;
